import _defineProperty from "/var/log/nginx/source/CateringManagerX/CateringManager_Html/node_modules/_@babel_runtime-corejs2@7.13.7@@babel/runtime-corejs2/helpers/esm/defineProperty";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import imageUpload from "components/imageUpload.vue";
import stuActivtyUpload from "components/stuActivtyUpload.vue";
export default {
  data: function data() {
    return {
      page: 1,
      pageSize: 10,
      totalCount: 0,
      stuName: "",
      schoolName: "",
      idCard: "",
      certificateNum: "",
      examinationTypeId: "",
      examinationGradeId: "",
      list: [],
      from: {
        id: "",
        studentName: "",
        examName: "",
        examTime: "",
        examinationTypeId: "",
        examinationType: "",
        examinationGradeId: "",
        examinationGrade: "",
        siteName: "",
        idCard: "",
        qualifiedState: "合格",
        certificateNum: "",
        dateofIssue: "",
        examYMEnglish: "",
        examinationGradeEnglish: "",
        studentNamePinyin: "",
        studentUrl: "",
        // 
        schoolName: "",
        peixunName: "",
        peixunTime: "",
        awardingUnit: "",
        effectiveTime: ""
      },
      files: [],
      urlAliyunOSS: "/api/XOrg/osssign/getsign",
      //编辑信息
      dialogFormVisible: false,
      //导入
      ImportDialogVisible: false,
      // uploadUrl: "/api/XOrg/CertificateManager/uploadExcelTea",
      fileList: [],
      //导入文件
      errorList: [],
      //错误信息
      certTypeList: [],
      certGradeList: [],
      certTypeId: '',
      searchCertTypeList: [],
      searCertGradeList: [],
      // 导入结果
      dataResultVisible: false,
      count: 0,
      successNum: 0,
      successFileName: "",
      failNum: 0,
      failFileName: "",
      // 批量删除
      DeleteAllDialogVisible: false,
      deleteStartTime: "",
      deleteEndTime: "",
      // 头像上传
      touXiangDialog: false,
      TisiDialog: false,
      tisiList: []
    };
  },
  components: {
    imageUpload: imageUpload,
    stuActivtyUpload: stuActivtyUpload
  },
  computed: {
    failUploadFileUrl: function failUploadFileUrl() {
      return decodeURI("/api/XOrg/ResultsManager/uploadFile?fileName=" + this.failFileName);
    },
    successUploadFileUrl: function successUploadFileUrl() {
      return decodeURI("/api/XOrg/ResultsManager/uploadFile?fileName=" + this.successFileName);
    },
    uploadUrl: function uploadUrl() {
      return "/api/XOrg/CertificateManager/uploadExcelTea?type=2&certificateId=" + this.certificateId;
    }
  },
  props: {
    certificateId: {
      default: "",
      type: String
    }
  },
  created: function created() {
    this.getStudentResultInfo();
    this.getCertificateType();
    this.getSearchCertificateType();
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    "from.examinationTypeId": function fromExaminationTypeId(val) {
      this.getCertificateGrade();
    },
    // eslint-disable-next-line no-unused-vars
    "examinationTypeId": function examinationTypeId(val) {
      this.getSearchCertificateGrade();
    }
  },
  methods: {
    //上传头像弹窗
    openTXtDialog: function openTXtDialog() {
      this.touXiangDialog = true;
    },
    //学生头像上传
    onAllFilesUpload: function onAllFilesUpload(file) {
      var _this = this;

      this.$http.post("/api/XOrg/CertificateManager/saveCertificateFile", {
        fileList: JSON.stringify(file),
        certificateId: this.certificateId
      }).then(function (res) {
        if (res.code > 0) {
          if (res.list.length == 0) {
            _this.$message.success(res.msg);

            _this.touXiangDialog = false;
          } else {
            _this.TisiDialog = true;
            _this.tisiList = res.list;
          }

          _this.getStudentResultInfo();
        } else {
          _this.$message.warning(res.msg);
        }
      });
    },
    deleteAll: function deleteAll() {
      var _this2 = this;

      var that = this;
      this.$confirm("此操作将删除该时间段证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        that.$http.post("/api/XOrg/CertificateManager/deleteCertificateAll", {
          startTime: _this2.deleteStartTime,
          endTime: _this2.deleteEndTime
        }).then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.DeleteAllDialogVisible = false;
            that.getStudentResultInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
      });
    },
    cancelDeleteAll: function cancelDeleteAll() {
      this.DeleteAllDialogVisible = false;
      this.deleteStartTime = "";
      this.deleteEndTime = "";
    },
    getSearchCertificateType: function getSearchCertificateType() {
      var that = this;
      this.$http.post("/api/XOrg/CertificateTypeManager/getCertificateType", {
        type: 2,
        certificateId: this.certificateId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.searchCertTypeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    getSearchCertificateGrade: function getSearchCertificateGrade() {
      var that = this;
      this.$http.post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
        typeId: this.examinationTypeId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.searCertGradeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    getCertificateType: function getCertificateType() {
      var that = this;
      this.$http.post("/api/XOrg/CertificateTypeManager/getCertificateType", {
        type: 2,
        certificateId: this.certificateId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.certTypeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    typeChnage: function typeChnage() {
      // this.getCertificateGrade();
      this.from.examinationGradeId = "";
    },
    getCertificateGrade: function getCertificateGrade() {
      var that = this;
      this.$http.post("/api/XOrg/CertGradeMgr/getCertificateGrade", {
        typeId: this.from.examinationTypeId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.certGradeList = rst.list;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    cancelInfo: function cancelInfo() {
      this.from.id = "";
      this.from.studentName = "";
      this.from.examName = "";
      this.from.examTime = "";
      this.from.examinationTypeId = "";
      this.from.examinationType = "";
      this.from.examinationGradeId = "";
      this.from.examinationGrade = "";
      this.from.siteName = "";
      this.from.idCard = "";
      this.from.qualifiedState = "";
      this.from.certificateNum = "";
      this.from.dateofIssue = "";
      this.from.examYMEnglish = "";
      this.from.examinationGradeEnglish = "";
      this.from.studentNamePinyin = "";
      this.from.studentUrl = ""; //

      this.from.schoolName = "";
      this.from.peixunName = "";
      this.from.peixunTime = "";
      this.from.awardingUnit = "";
      this.from.effectiveTime = "";
      this.dialogFormVisible = false;
    },
    onSuccess: function onSuccess(res) {
      if (res.code > 0) {
        this.ImportDialogVisible = false;
        this.fileList = [];
        this.dataResultVisible = true;
        this.count = res.info.count;
        this.successNum = res.info.successNum;
        this.successFileName = res.info.successFileName;
        this.failNum = res.info.failNum;
        this.failFileName = res.info.failFileName;
        this.getStudentResultInfo();
      } else {
        this.fileList = [];
        this.$message.warning(res.msg);
      }
    },
    //导入题库
    importFile: function importFile() {
      this.$refs.upload.submit();
    },
    //清除数据
    cancel: function cancel() {
      this.ImportDialogVisible = false;
      this.fileList = [];
    },
    addInfo: function addInfo() {
      this.dialogFormVisible = true;
    },
    //编辑
    editInfo: function editInfo() {
      var that = this;
      this.$http.post("/api/XOrg/CertificateManager/addOrEditCertificate", {
        id: this.from.id,
        studentName: this.from.studentName,
        examName: this.from.examName,
        examTime: this.from.examTime,
        examinationGradeId: this.from.examinationGradeId,
        examinationTypeId: this.from.examinationTypeId,
        siteName: this.from.siteName,
        idCard: this.from.idCard,
        qualifiedState: this.from.qualifiedState,
        certificateNum: this.from.certificateNum,
        dateofIssue: this.from.dateofIssue,
        studentUrl: this.from.studentUrl,
        //
        schoolName: this.from.schoolName,
        peixunName: this.from.peixunName,
        peixunTime: this.from.peixunTime,
        awardingUnit: this.from.awardingUnit,
        effectiveTime: this.from.effectiveTime,
        type: 2,
        certificateId: this.certificateId
      }).then(function (rst) {
        if (rst.code > 0) {
          that.$message.success(rst.msg);
          that.cancelInfo();
          that.getStudentResultInfo();
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //弹出框赋值
    handleEdit: function handleEdit(row) {
      this.from.id = row.id;
      this.from.studentName = row.studentName;
      this.from.examName = row.examName;
      this.from.examTime = row.examTime;
      this.from.examinationGradeId = row.examinationGradeId;
      this.from.examinationTypeId = row.certificateTypeId;
      this.from.siteName = row.siteName;
      this.from.idCard = row.idCard;
      this.from.qualifiedState = row.qualifiedState;
      this.from.certificateNum = row.certificateNum;
      this.from.dateofIssue = row.dateofIssue;
      this.from.examYMEnglish = row.examYMEnglish;
      this.from.examinationGradeEnglish = row.examinationGradeEnglish;
      this.from.studentNamePinyin = row.studentNamePinyin;
      this.from.studentUrl = row.studentUrl; //

      this.from.schoolName = row.schoolName;
      this.from.peixunName = row.peixunName;
      this.from.peixunTime = row.peixunTime;
      this.from.awardingUnit = row.awardingUnit;
      this.from.effectiveTime = row.effectiveTime;
      this.dialogFormVisible = true;
    },
    //删除
    deleteInfo: function deleteInfo(id) {
      var that = this;
      this.$confirm("此操作将删除该证书数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        that.$http.post("/api/XOrg/CertificateManager/deleteCertificateInfo", {
          ids: id
        }).then(function (rst) {
          if (rst.code > 0) {
            that.$message.success(rst.msg);
            that.getStudentResultInfo();
          } else {
            that.$message.warning(rst.msg);
          }
        });
      });
    },
    //查询
    getStudentResultInfo: function getStudentResultInfo() {
      var _this$$http$post;

      var that = this;
      this.$http.post("/api/XOrg/CertificateManager/getCertificateList", (_this$$http$post = {
        studentName: this.stuName,
        schoolName: this.schoolName,
        idCard: this.idCard,
        ExaminationGradeId: this.examinationGradeId,
        CertificateTypeId: this.examinationTypeId,
        certificateNum: this.certificateNum,
        certificateId: this.certificateId,
        type: 2
      }, _defineProperty(_this$$http$post, "certificateId", this.certificateId), _defineProperty(_this$$http$post, "PageSize", that.pageSize), _defineProperty(_this$$http$post, "page", that.page), _this$$http$post)).then(function (rst) {
        if (rst.code > 0) {
          that.list = rst.list;
          that.page = rst.pagination.pageIndex;
          that.pageSize = rst.pagination.pageSize;
          that.totalCount = rst.pagination.totalCount;
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getStudentResultInfo();
    },
    onPageChangeHandler: function onPageChangeHandler(val) {
      this.page = val;
      this.getStudentResultInfo();
    }
  }
};